import React from 'react'
import { H2Generator } from '../../functions/H2Generator'
import { api } from '../../../../src/services/api'
import { ArticleTable } from './ArticleTableList/index'
import { ArticleCreation } from './ArticleCreation'
import { ConfirmationModal } from '../UserAdmin/ConfirmationModal'

import styles from './article.module.scss'
import { motion, useAnimation } from 'framer-motion'

interface ArticleProps {
    props?: any
}

interface Artigo {
    ID: any,
    CM_CAT_UNIVERSAL: any,
    CM_CAT_ID: any,
    CM_AUTOR: string,
    CM_TITULO: string,
    CM_DESCRICAO: string,
    CM_CONTEUDO: any
}

interface Categoria {
    ID: number,
    CM_NOME: string,
    CM_PARENTE_ID: any
}

export function ArticleAdmin(props: ArticleProps) {

    const currentUser = localStorage.getItem('userData') || ''

    const [data, setData] = React.useState<Artigo[]>([])
    const [catgData, setCatgData] = React.useState<Categoria[]>([])

    React.useEffect(() => {
        const fetchData = async () => {
            const result = await api.get('/artigos')
                .then((resp => resp.data))

            setData(result.data)
        }

        fetchData()
    }, [])

    React.useEffect(() => {
        const fetchData = async () => {
            const result = await api.get('/categorias')
                .then((resp => resp.data))

            setCatgData(result)
        }

        fetchData()
    }, [])

    function getArticle() {
        const fetchData = async () => {
            const result = await api.get('/artigos')
                .then((resp => resp.data))

            setData(result.data)
        }

        fetchData()
    }

    const [articleData, setArticleData] = React.useState({
        ID: '',
        CM_TITULO: '',
        CM_DESCRICAO: '',
        CM_CAT_ID: '',
        CM_AUTOR: JSON.parse(currentUser).name,
        CM_CONTEUDO: ''
    })

    const [articleDeleteData, setArticleDeleteData] = React.useState({
        ID: ''
    })

    const [confirmationMessage, setConfirmationMessage] = React.useState('')
    const [confirmationStatus, setConfirmationStatus] = React.useState(styles.confirmationModalContainerOff)

    function putArticle(artigo: any) {
        setConfirmationMessage(`Você tem certeza que deseja editar o artigo "${artigo.CM_TITULO}"?`)
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setConfirmationStatus(styles.confirmationModalContainerPencilOn)
        getArticle()
        setArticleData({
            ID: artigo.ID,
            CM_TITULO: artigo.CM_TITULO,
            CM_DESCRICAO: artigo.CM_DESCRICAO,
            CM_CAT_ID: artigo.CM_CAT_ID,
            CM_CONTEUDO: artigo.CM_CONTEUDO,
            CM_AUTOR: artigo.CM_AUTOR
        })
    }

    function confirmPutArticle() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setMotionsForm('articleButton')
    }

    function cancelPutArticle() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setArticleData({
            ID: '',
            CM_TITULO: '',
            CM_DESCRICAO: '',
            CM_CAT_ID: '',
            CM_CONTEUDO: '',
            CM_AUTOR: ''
        })
    }

    function removeArticle(artigo: any) {
        setConfirmationMessage(`Você tem certeza que deseja excluir o artigo "${artigo.CM_TITULO}"?`)
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setConfirmationStatus(styles.confirmationModalContainerTrashOn)

        setArticleDeleteData({
            ID: artigo.ID
        })
    }

    function confirmRemoveArticle() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        api.delete(`/artigos/${articleDeleteData.ID}`)
            .then(() => {
                getArticle()
            })
    }

    function cancelRemoveArticle() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setArticleDeleteData({
            ID: ''
        })
    }

    const articleButtonAnimation = useAnimation()
    const formsContainerAnimation = useAnimation()

    function setMotionsForm(element: string) {
        if (element === 'articleButton') {
            articleButtonAnimation.start({
                opacity: 0,
                y: -10
            })

            formsContainerAnimation.start({
                height: '739px',
                marginTop: '-100px'
            })
        }
    }

    function resetMotionsForm(element: string) {
        if (element === 'articleButton') {
            articleButtonAnimation.start({
                opacity: 1,
                y: 0
            })

            formsContainerAnimation.start({
                height: '0px',
                marginTop: '20px'
            })
        }
    }

    return (
        <div className={styles.allContainer}>
            <ConfirmationModal
                title={confirmationMessage}
                status={confirmationStatus}
                confirm={articleData.ID.length === 0 ? confirmRemoveArticle : confirmPutArticle}
                cancel={articleData.ID.length === 0 ? cancelRemoveArticle : cancelPutArticle}
                iconConfirmation={articleData.ID.length === 0 ? 'faTrashAlt' : 'faPencilAlt'} />
            <div className={styles.titleContainer}>
                <H2Generator textos={["Controle de Artigos", "Aqui você pode criar, editar e remover artigos."]} />
            </div>
            <div className={styles.flexContainer}>
                <div className={styles.articleButtonContainer}>
                    <motion.button
                        className={styles.buttonCategory}
                        onClick={() => setMotionsForm('articleButton')}
                        animate={articleButtonAnimation}
                        transition={{ ease: 'easeOut' }}
                        whileTap={{ scale: 0.95 }}>Criar Artigo</motion.button>
                </div>
            </div>
            <div className={styles.ArticleCreationContainer}>
                <motion.div
                    className={styles.formsContainer}
                    animate={formsContainerAnimation}
                    transition={{ duration: 0.3 }}>
                    <ArticleCreation
                        catgData={catgData}
                        articleData={articleData}
                        updateData={getArticle}
                        changeContainerArticle={resetMotionsForm}
                        cleanArticleData={cancelPutArticle}
                    />
                </motion.div>
            </div>

            <div className={styles.tableContainer}>
                <hr className={styles.hr} />
                <ArticleTable
                    data={data}
                    putArticle={putArticle}
                    removeArticle={removeArticle} />
            </div>
        </div>
    )
}